import {patternsRepository} from "./Patterns/patternsRepository";

export const repositories = {
  ...patternsRepository,
};

export type Api = typeof repositories;

export const BASE_URL = 'https://magic-needle-api.fly.dev';
